export default "__VITE_ASSET__BwFZ9TTS__"